import styled from 'styled-components'
import { color, breakpoint } from '@configs/utilities'

export const MainHeroHeadingH1 = styled.h1`
  font-size: 38px;
  font-weight: 700;
  letter-spacing: 0.2px;
  line-height: 40px;
  color: ${color.font};

  @media screen and (min-width: ${breakpoint.md}) {
    font-size: 42px;
    line-height: 50px;
  }

  @media screen and (min-width: ${breakpoint.xl}) {
    font-size: 48px;
    line-height: 65px;
  }

  @media screen and (min-width: ${breakpoint.xxxl}) {
    font-size: 56px;
  }
`

export const MainHeroHeadingHorizontalH1 = styled.h1`
  font-size: 36px;
  font-weight: 700;
  letter-spacing: 0.2px;
  line-height: 40px;
  color: ${color.font};

  @media screen and (min-width: ${breakpoint.md}) {
    font-size: 42px;
    line-height: 50px;
  }

  @media screen and (min-width: ${breakpoint.xl}) {
    font-size: 48px;
    line-height: 65px;
  }

  @media screen and (min-width: ${breakpoint.xxxl}) {
    font-size: 52px;
  }
`

export const HeadingH1 = styled.h1`
  font-size: 32px;
  font-weight: 700;
  letter-spacing: 0.2px;
  color: ${color.font};

  @media screen and (min-width: ${breakpoint.xl}) {
    font-size: 40px;
  }
`

export const HeadingH2 = styled.h2`
  font-size: 30px;
  font-weight: 600;
  color: ${color.font};
  letter-spacing: 0.2px;
  line-height: 40px;

  @media screen and (min-width: ${breakpoint.md}) {
    font-size: 32px;
    line-height: 45px;
  }

  @media screen and (min-width: ${breakpoint.xl}) {
    font-size: 38px;
    line-height: 50px;
  }

  @media screen and (min-width: ${breakpoint.xxxl}) {
    font-size: 44px;
    line-height: 50px;
  }
`

export const HeadingH3 = styled.h3`
  font-size: 20px;
  font-weight: 700;
  color: ${color.font};

  @media screen and (min-width: ${breakpoint.xl}) {
    font-size: 26px;
  }
`

export const CardTitle = styled.p`
  font-weight: 500;
  font-size: 26px;
  line-height: 40px;
`

export const CardTitleCustom = styled.p`
  font-weight: 500;
  font-size: 26px;
  line-height: 40px;
`

export const StyledTitle1 = styled.p`
  font-weight: 500;
  font-size: 26px;
  color: ${color.font};
  letter-spacing: 0.2px;
  line-height: 40px;

  @media screen and (min-width: ${breakpoint.md}) {
    font-size: 32px;
    line-height: 45px;
  }

  @media screen and (min-width: ${breakpoint.xl}) {
    font-size: 32px;
    line-height: 50px;
  }

  @media screen and (min-width: ${breakpoint.xxxl}) {
    font-size: 36px;
    line-height: 50px;
  }
`

export const DescriptionDisplay1 = styled.p`
  font-size: 18px;
  font-weight: 300;
  color: ${color.font};
  line-height: 24px;

  @media screen and (min-width: ${breakpoint.md}) {
    font-size: 20px;
    line-height: 28px;
  }

  @media screen and (min-width: ${breakpoint.xl}) {
    font-size: 22px;
    line-height: 30px;
  }

  @media screen and (min-width: ${breakpoint.xxxl}) {
    font-size: 24px;
    line-height: 32px;
  }
`

export const DescriptionDisplay2 = styled.p`
  font-size: 18px;
  font-weight: 300;
  color: ${color.font};
  line-height: 24px;

  @media screen and (min-width: ${breakpoint.md}) {
    font-size: 20px;
    line-height: 28px;
  }

  @media screen and (min-width: ${breakpoint.xl}) {
    font-size: 20px;
    line-height: 32px;
  }

  @media screen and (min-width: ${breakpoint.xxxl}) {
    font-size: 22px;
  }
`

export const DescriptionDisplay3 = styled.p`
  font-size: 14px;
  font-weight: 300;
  color: ${color.font};

  @media screen and (min-width: ${breakpoint.xl}) {
    font-size: 16px;
  }
`

export const StyledDescription1 = styled.p`
  font-weight: 300;
  font-size: 16px;
  line-height: 20px;
  color: ${color.font};

  @media screen and (min-width: ${breakpoint.md}) {
    font-size: 18px;
  }

  @media screen and (min-width: ${breakpoint.xl}) {
    line-height: 24px;
  }
`

export const RegularText = styled.p`
  font-size: 16px;
  font-weight: 300;
  color: ${color.font};
  line-height: 24px;
`

export const RegularTextCustom = styled.p`
  font-size: 16px;
  font-weight: 300;
  color: ${color.font};
  line-height: 24px;
`

export const SmallText = styled.p`
  font-size: 14px;
  font-weight: 300;
  color: ${color.font};
  line-height: 20px;
`

export const HandwritingSubtitle = styled.p`
  font-family: 'Caveat Brush', cursive;
  font-size: 24px;
  font-weight: 300;
  color: ${color.blue};
  text-align: center;

  @media screen and (min-width: ${breakpoint.md}) {
    width: 85%;
  }

  @media screen and (min-width: ${breakpoint.lg}) {
    width: 70%;
  }

  @media screen and (min-width: ${breakpoint.xl}) {
    font-size: 30px;
  }
`

export const HandwritingPointer = styled.p`
  font-family: 'Caveat Brush', cursive;
  font-size: 20px;
  font-weight: 300;
  color: ${color.blue};
  text-align: center;

  @media screen and (min-width: ${breakpoint.xl}) {
    font-size: 24px;
  }
`

export const ExplainButton = styled.span`
  font-size: 11px;
  font-weight: 600;
  color: ${color.font};
  opacity: 0.5;
  display: block;
  text-align: center;
`

export const BulletPointsText = styled.span`
  font-weight: 300;
  font-size: 16px;
  color: ${color.font};

  @media screen and (min-width: ${breakpoint.lg}) {
    font-size: 18px;
  }
`

export const TextImageComponentTitle = styled.p`
  font-weight: 500;
  letter-spacing: 0.2px;
  line-height: 40px;
  font-size: 26px;
  color: ${color.font};

  @media screen and (min-width: ${breakpoint.md}) {
    max-width: 380px;
    font-size: 32px;
    line-height: 45px;
  }

  @media screen and (min-width: ${breakpoint.xl}) {
    line-height: 50px;
  }

  @media screen and (min-width: ${breakpoint.xxxl}) {
    font-size: 36px;
    line-height: 50px;
  }
`
export const TextImageComponentDescription = styled.p`
  font-weight: 300;
  font-size: 16px;
  color: ${color.font};

  @media screen and (min-width: ${breakpoint.md}) {
    font-size: 18px;
  }
`
